import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { environment } from '../environments/environment';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { provideCac } from '@panel';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { enGB } from 'date-fns/locale';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideCac('admin', environment),
    { provide: MAT_DATE_LOCALE, useValue: enGB },
    provideDateFnsAdapter(),
  ],
};
